<template>
  <BaseModal>
    <p class="comment c-white pt-0">
      {{ $t('chain_settings.cafe_modal_title')}}
    </p>
    <BlackSelect class="iqos-group-item"  v-model="cafe_id">
        <option :value="cafe._id" v-for="cafe in cafes" :key="cafe._id">
            {{ cafe.name }} ({{cafe.address}})
        </option>
    </BlackSelect>

    <div class="modal-controls">
        <DashboardButton variant="danger" @click="$emit('close')">
            {{ $t('chain_settings.cafe_modal_cancel')}}
        </DashboardButton>

        <DashboardButton variant="success" @click="$emit('confirm', cafe_id)" :disabled="!cafe_id">
            {{ $t('chain_settings.cafe_modal_confirm')}}
        </DashboardButton>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import DashboardButton from "@/components/DashboardButton.vue";

export default {
  components: {
    BaseModal,
    DashboardButton,
    BlackSelect,
  },
  data() {
      return {
          cafe_id: null
      }
  },
  computed: {
    cafes() {
      return this.$store.getters.chainCafes();
    },
  },
};
</script>

<style scoped>
.modal-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
  width: 100%;
}
</style>